import { notConnectedUserSegmentIds, userSegmentIds } from "../consts";
import { getState } from "../state/store";
import adminUserUtils from "./adminUserUtils";
import arrayUtil from "./arrayUtil";
import dateUtil from "./dateUtil";
import userUtil from "./userUtil";

// temporarily assigns random segments to users
const getUserSegments = (users = []) => {
  const segmentIds = [
    ...Object.values(userSegmentIds),
    ...Object.values(notConnectedUserSegmentIds)
  ];

  if (!users?.length) {
    return [];
  }

  return users?.map((user) => {
    const segmentIdx = Math.floor(Math.random() * segmentIds.length);
    const conversionType = !!Math.floor(Math.random() * 2);

    const isAdminUser = adminUserUtils.isUserAdmin(user);

    const markets = isAdminUser
      ? Array.isArray(user?.markets)
        ? user?.markets
        : []
      : userUtil.getUserMarkets(user?.groups);

    return {
      ...user,
      markets,
      segment: segmentIds[segmentIdx],
      previousSegment: segmentIds[segmentIdx],
      conversionType
    };
  });
};

const filterUserInsights = (users, filters) => {
  const { segments, conversionType, markets: selectedMarkets } = filters;

  const selectedSegments = segments ? segments?.map((segment) => segment.id) : [];
  const selectedConversionType =
    conversionType === "conversion" ? true : conversionType === "non-conversion" ? false : null;

  let result = users;

  if (selectedSegments?.length) {
    result = result.filter((user) => selectedSegments.includes(user.segment));
  }

  if (selectedConversionType != null) {
    result = result.filter((user) => user.conversionType === selectedConversionType);
  }

  if (selectedMarkets?.length) {
    result = result.filter((user) => {
      return arrayUtil.includesAll(selectedMarkets, user.markets);
    });
  }

  return result;
};

const formatInsightsForExport = (users = [], groupAssignments = []) => {
  const groups = getState()?.userGroups?.groups ?? [];

  const formattedUsees = users.map((user) => {
    const {
      email,
      firstName,
      lastName,
      active,
      markets,
      createdAtTs,
      lastLoginTs,
      segment,
      previousSegment,
      conversionType
    } = user ?? {};

    const userGroupIds = groupAssignments
      ?.filter((el) => el.email === email)
      ?.map((el) => el?.targetGroupId);
    const userGroups = userGroupIds?.length
      ? groups?.filter((el) => userGroupIds.includes(el?.id))?.map((el) => el?.name)
      : [];

    const result = {
      email,
      firstName,
      lastName,
      active,
      markets,
      userGroups: userGroups?.join(", "),
      createdAtTs: dateUtil.formatDateFromTimestamp(createdAtTs),
      lastLoginTs: dateUtil.formatDateFromTimestamp(lastLoginTs),
      segment,
      previousSegment,
      isConversionable: conversionType
    };

    return result;
  });

  return formattedUsees;
};

const userInsightsUtils = { getUserSegments, filterUserInsights, formatInsightsForExport };

export default userInsightsUtils;
